<template>
	<div>
		<Header></Header>
		<Nav></Nav>
		<div class="framework">
			<div class="frame">
				<div class="frame-left">
					<p class="frame-left-top">组织架构</p>
					<div class="frame-left-ss">
						<img class="left-ss" @click="searchFrames()" src="../../../assets/purchase/image/framework/ss.png" />
						<input placeholder="搜索成员/部门" v-model="searchFrame" ref="searchFrame" />
						<img v-show="level == 0" @click="addFrame()" class="left-tj" src="../../../assets/purchase/image/framework/tianjia.png" />
					</div>
					<div v-show="level == 0" v-for="(value,index) in frame_list" class="el-personal" :class="{active:isActive==index}" @click="showdifference(index)">
						<i class="el-icon-folder-opened"></i>
						{{value.name}} <img class="zz" @click="clickbj(index)" src="../../../assets/purchase/image/framework/zz.png" />
						<div @mouseleave="mouseLeave(index)" class="box" :class="{disbox:isBianji==index}">
							<div class="edit" @click="modifyFrame(index)">编辑</div>
							<div class="edit" @click="deleteFrame(index)">删除</div>
						</div>
					</div>
					<div v-show="level == 1" v-for="(value,index) in frame_list" class="el-personal" :class="{active:isActive==index}" @click="showdifference(index)">
						<i class="el-icon-folder-opened"></i>{{value.name}} 
					</div>
				</div>

				<div class="frame-right">
					<div class="frame-right-top">
						<div class="right-top-txt">
							<div v-show="address_btn == 1" @click="framePeo(1)" class="frame-personal" :class="{active:framePersonal == 1}">部门人员</div>
							<div v-show="address_btn == 1" @click="framePeo(2)" class="frame-personal" :class="{active:framePersonal == 2}">部门地址</div>
							<div v-show="address_btn == 1 && level == 0" @click="framePeo(3)" class="frame-personal" :class="{active:framePersonal == 3}">发票信息</div>
							<div v-show="address_btn == 1 && level == 1 && qypay_type == 1" @click="framePeo(3)" class="frame-personal" :class="{active:framePersonal == 3}">发票信息</div>
						</div>
						<div class="right-top-button">
							<div class="right-top-btn" v-show="framePersonal == 1 && framePer == 1" @click="addPeople">添加成员</div>
							<div class="right-top-btn" v-show="framePersonal == 2 && framePer == 2" @click="addAddress">添加地址</div>
							<div class="right-top-btn" v-show="framePersonal == 3 && framePer == 3" @click="addInvoice">添加发票</div>
						</div>
					</div>
					<div v-show="this.framePersonal == 1">
						<div class="frame-right-center">
							<div v-show="this.funds == -1" class="right-center-funds right-center-funds-one">
								<p><span>0元</span></p>
								<p>采购经费</p>
							</div>
							<div v-show="this.is_limit == 1" class="right-center-funds right-center-funds-one">
								<p><span>不限制</span></p>
								<p>采购经费</p>
							</div>
							<div v-show="this.funds <= 9999 && this.funds >= 0 && this.is_limit != 1" class="right-center-funds right-center-funds-one">
								<p><span>{{this.funds}}元</span></p>
								<p>采购经费</p>
							</div>
							<div v-show="this.funds > 9999 && this.is_limit != 1" class="right-center-funds right-center-funds-one">
								<p><span>{{this.funds / 10000}}万</span></p>
								<p>采购经费</p>
							</div>
							<div class="right-center-funds">
								<p>
									<span v-if="pay_type == 0">月结</span>
									<span v-if="pay_type == 1">货到付款</span>
								</p>
								<p>结算方式</p>
							</div>
						</div>
						<div class="frame-right-tab">
							<table class="right-tab">
								<tr>
									<th width="180px">人员</th>
									<th width="225px">账号</th>
									<th width="275px">手机号</th>
									<th width="100px">操作</th>
								</tr>
								<tr v-for="(val,index) in per_list">
									<td>{{val.nickname}}<span v-show="val.level == 1">上级</span></td>
									<td>{{val.username}}</td>
									<td>{{val.phone}}</td>
									<td class="operation">
										<span @click="modPerson(index)">编辑</span>
										<span @click="deletePersone(index)">删除</span>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<div v-show="this.framePersonal == 2">
						<div class="frame-right-center">
							<div class="frame-right-tab">
								<table class="right-tab">
									<tr>
										<th width="180px">收货人</th>
										<th width="225px">手机号</th>
										<th width="275px">详细地址</th>
										<th width="100px">操作</th>
									</tr>
									<tr v-for="(val,index) in district_list">
										<td>{{val.name}}<span v-show="val.is_default == 1">默认地址</span></td>
										<td>{{val.mobile}}</td>
										<td>{{val.province}}-{{val.city}}-{{val.district}}-{{val.detail}}</td>
										<td class="operation">
											<span @click="modAddress(index)">编辑</span>
											<span @click="deladdressList(index)">删除</span>
										</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
					<div v-show="this.framePersonal == 3">
						<div class="frame-right-center">
							<div class="frame-right-tab">
								<table class="right-tab">
									<tr>
										<th width="120px">单位名称</th>
										<th width="120px">统一社会信用代码</th>
										<th width="120px">注册地址</th>
										<th width="80px">注册电话</th>
										<th width="120px">开户银行</th>
										<th width="120px">银行账号</th>
										<th width="100px">操作</th>
									</tr>
									<tr v-for="(val,index) in invoice_list">
										<td>{{val.header}}<span v-show="val.is_default == 1">默认发票</span></td>
										<td>{{val.taxpayer}}</td>
										<td>{{val.detail ? val.detail.reg_address : ''}}</td>
										<td>{{val.detail ? val.detail.reg_phone : ''}}</td>
										<td>{{val.detail ? val.detail.reg_bank : ''}}</td>
										<td>{{val.detail ? val.detail.bank_number : ''}}</td>
										<td class="operation">
											<span @click="modInvoices(index)">编辑</span>
											<span @click="delInvoices(index)">删除</span>
										</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 新建部门 -->
		<div class="addpersonal">
			<el-dialog title="新建部门" :visible.sync="dialogFormVisible">
				<div class="addper">
					<div class="add-per">
						<div class="ttshop_singtop" :class="{ttshop_singtop_active:pwShow}">
							<p>
								<i>
									<img src="../../../assets/images/ttshop_samil.png" alt />
								</i>
								<span>{{pwTitle}}</span>
							</p>
						</div>
						<div class="add-data">
							<p><span>部门名称：</span><input type="text" placeholder="输入部门名称" ref="addname" v-model="addname" /></p>
						</div>
						<div class="add-data">
							<p><span>采购经费：</span><input type="text" placeholder="输入采购经费" ref="addfunds" v-model="addfunds" /></p>
						</div>
						<div class="add-data" v-if="pay_type == 1">
							<p><span>结算方式：</span>
								<select v-model="settlement" @change="getValue">
									<option value="">请选择付款方式</option>
									<option v-for="item in settlement_list">{{item}}</option>
								</select>
							</p>
						</div>
						<div class="add-data add-data-end" @click="change_farme()">
							<div class="default-img">
								<img src="../../../assets/images/select_checked.png" alt v-show="frame_is_default" />
								<img src="../../../assets/images/select_unchecked.png" alt v-show="!frame_is_default" />
							</div>设为不限制金额
						</div>
					</div>
					<div v-show="xiuGai == 1" class="newly-build" @click="addBtnframe()">
						新建
					</div>
					<div v-show="xiuGai == 2" class="newly-build" @click="modBtnframe()">
						修改
					</div>
				</div>
			</el-dialog>
		</div>

		<!-- 添加地址 -->
		<div class="addpersonal">
			<el-dialog title="添加地址" :visible.sync="addAddresslist">
				<div class="addper">
					<div class="add-per">
						<div class="ttshop_singtop" :class="{ttshop_singtop_active:pwShow}">
							<p>
								<i>
									<img src="../../../assets/images/ttshop_samil.png" alt />
								</i>
								<span>{{pwTitle}}</span>
							</p>
						</div>
						<div class="add-data">
							<p><span>收货人：</span><input type="text" placeholder="输入收货人名称" v-model="consignee_name" /></p>
						</div>
						<div class="add-data">
							<p><span>手机号：</span><input type="text" placeholder="输入手机号" v-model="consignee_phone" /></p>
						</div>
						<div class="add-data">
							<span class="add-data-ress">所在地区：</span>
							<el-cascader :options="addressData_list" :props="{value:'id',label:'name',children: 'list'}" v-model="address_province"
							 @change="provinceChange"></el-cascader>
							<template v-if="address_province_type">
								请选择地区
							</template>
						</div>
						<div class="add-data">
							<p><span>详细地址：</span><input type="text" placeholder="街道、小区、楼牌号等" v-model="address_detail" /></p>
						</div>
						<div class="add-data add-data-end" @click="change_default()">
							<div class="default-img">
								<img src="../../../assets/images/select_checked.png" alt v-show="address_is_default" />
								<img src="../../../assets/images/select_unchecked.png" alt v-show="!address_is_default" />
							</div>设为默认收货地址
						</div>
					</div>
					<div v-show="xiuGai == 1" class="newly-build" @click="addBtnaddress()">
						新建
					</div>
					<div v-show="xiuGai == 2" class="newly-build" @click="modBtnaddress()">
						修改
					</div>
				</div>
			</el-dialog>
		</div>


		<!-- 添加成员-->
		<div class="addpersonal">
			<el-dialog title="添加成员" :visible.sync="addMembers">
				<div class="addper">
					<div class="add-per">
						<div class="ttshop_singtop" :class="{ttshop_singtop_active:pwShow}">
							<p>
								<i>
									<img src="../../../assets/images/ttshop_samil.png" alt />
								</i>
								<span>{{pwTitle}}</span>
							</p>
						</div>
						<div class="add-data">
							<p><span>姓名：</span><input type="text" ref="pername" v-model="pername" placeholder="输入姓名" /></p>
						</div>
						<div class="add-data" v-show="level == 0">
							<p><span>职务：</span>
								<select v-model="examine" @change="getExamine">
									<option value="">请选择审批人</option>
									<option v-for="item in examine_list">{{item}}</option>
								</select>
							</p>
						</div>
						<div class="add-data" v-show="level == 1">
							<p><span>职务：</span>
								<select v-model="examine" @change="getExamine">
									<option value="">请选择添加人员类别</option>
									<option>采购员</option>
								</select>
							</p>
						</div>
						<div class="add-data">
							<p><span>账号：</span><input type="text" ref="pertext" v-model="pertext" placeholder="设置账号" /></p>
						</div>
						<div class="add-data">
							<p><span>密码：</span><input type="password" ref="perpassword" v-model="perpassword" placeholder="输入密码" /></p>
						</div>
						<div class="add-data add-end">
							<p><span>手机号：</span><input type="number" ref="perphone" v-model="perphone" placeholder="输入手机号" /></p>
						</div>
					</div>
					<div class="newly-build" v-show="xiuGai == 1" @click="addBtnpeople()">
						添加
					</div>
					<div class="newly-build" v-show="xiuGai == 2" @click="modifyPerson()">
						修改
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 添加发票-->
		<div class="addpersonal">
			<el-dialog title="添加发票" :visible.sync="addInvoices">
				<div class="addper">
					<div class="add-per">
						<div class="ttshop_singtop" :class="{ttshop_singtop_active:pwShow}">
							<p>
								<i>
									<img src="../../../assets/images/ttshop_samil.png" alt />
								</i>
								<span>{{pwTitle}}</span>
							</p>
						</div>
						<div class="add-data">
							<p><span><i>*</i>发票类型：</span>
								<select v-model="invoice" @change="getInvoice">
									<option value="">请选择发票类型</option>
									<option v-for="item in invoice_addlist">{{item}}</option>
								</select>
							</p>
						</div>
						<div class="add-data">
							<p><span><i>*</i>单位名称：</span><input type="text" ref="invoice_name" v-model="invoice_name" placeholder="输入单位名称" /></p>
						</div>
						<div class="add-data">
							<p><span><i>*</i>信用代码：</span><input type="text" ref="invoice_num" v-model="invoice_num" placeholder="输入统一社会信用代码" /></p>
						</div>
						<div class="add-data" v-show="this.invoiceNum != 1">
							<p><span><i>*</i>注册地址：</span><input type="text" ref="invoice_address" v-model="invoice_address" placeholder="输入注册地址" /></p>
						</div>
						<div class="add-data" v-show="this.invoiceNum != 1">
							<p><span><i>*</i>注册电话：</span><input type="text" ref="invoice_phone" v-model="invoice_phone" placeholder="输入注册电话" /></p>
						</div>
						<div class="add-data" v-show="this.invoiceNum != 1">
							<p><span><i>*</i>开户银行：</span><input type="text" ref="invoice_bank" v-model="invoice_bank" placeholder="输入开户银行" /></p>
						</div>
						<div class="add-data add-end" v-show="this.invoiceNum != 1">
							<p><span><i>*</i>银行账号：</span><input type="text" ref="invoice_cartnumber" v-model="invoice_cartnumber"
								 placeholder="输入银行账号" /></p>
						</div>
						<div class="add-data add-data-end" @click="change_invoice()">
							<div class="default-img">
								<img src="../../../assets/images/select_checked.png" alt v-show="invoice_is_default" />
								<img src="../../../assets/images/select_unchecked.png" alt v-show="!invoice_is_default" />
							</div>设为默认发票
						</div>
					</div>
					<div class="newly-build" v-show="xiuGai == 1" @click="addBtnInvoices()">
						添加
					</div>
					<div class="newly-build" v-show="xiuGai == 2" @click="modifyInvoices()">
						修改
					</div>
				</div>
			</el-dialog>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/purchase/header/header";
	import Nav from "@/components/purchase/nav/nav";
	import Footer from "@/components/purchase/footer/footer";
	import "./framework.css";

	export default {
		components: {
			Header,
			Nav,
			Footer,
		},
		data() {
			return {
				route_url: this.$route.params.route_url,
				isActive: -1,
				isBianji: -1,
				frame_list: [], //部门列表
				searchFrame: '', //搜索部门
				address_btn: 0,
				framePer: 0,
				level: this.$store.state.qycg_user.level,
				per_list: [], //成员列表
				framePersonal: 1,
				ind: 0,
				keyword: '',
				dialogFormVisible: false,
				addMembers: false,
				name: "", //部门名称
				pay_type: this.$store.state.qycg_user.basics.pay_type, //结算方式
				qypay_type: this.$store.state.qycg_user.basics.pay_type, //结算方式
				funds: -1, //采购经费
				addname: "", //新建部门名称
				addpay_type: this.$store.state.qycg_user.basics.pay_type, //新建结算方式
				addfunds: "", //新建采购经费
				id: "", //部门id
				pwTitle: "", //错误提示
				pwShow: false, //错误隐藏

				//发票
				addInvoices: false,
				dep_id: '',
				invoice_addlist: ["增值税普通发票", "增值税专用发票"],
				invoice: '',
				invoiceNum: 0,
				invoice_is_default: 0, //是否默认发票
				invoice_id: '',   //发票id
				invoice_list: [], //发票列表
				invoice_name: "", //单位名称
				invoice_num: "", //统一社会信用代码
				invoice_address: "", //注册地址
				invoice_phone: "", //注册电话
				invoice_bank: "", //开户银行
				invoice_cartnumber: "", //银行账号

				//部门
				settlement_list: ["月结", "货到付款"], //结算
				settlement: '', //下拉返回值
				getSettement: 2, //结算返回值
				xiuGai: 1,
				is_limit: '',
				frame_is_default: 0, //是否不限制金额

				//人员
				examine_list: ["审核员", "采购员"], //审核列表
				examine: "", //选择审核人
				examineNum: 0, //审核人返回值
				per_id: "", //成员id
				pername: "", //添加人员名称
				pertext: "", //账号
				perpassword: "", //密码
				perphone: "", //手机号

				//地址
				addAddresslist: false, //地址弹框
				addressData_list: [], //省市区数据
				district_list: [], // 地址省市区列表
				address_province: [], // 地址-省市区
				address_is_default: 0, // 地址-是否设为默认地址
				address_province_type: false,
				address_detail: '', //收货详细地址
				id_default: '', //是否默认地址
				province_id: '', //省份id
				city_id: '', //城市id
				district_id: '', //区域id
				address_id: '', //地址id
				consignee_name: '', //收货人姓名
				consignee_phone: '', //收货人手机号
				address_detail: "", //地址详细信息
			}
		},
		created() {
			this.departmentapi();
			this.addressDatalist();
			this.qycgInvoicelist();
			let that = this;
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key === 13) {
					if (that.$refs.searchFrame.value) {
						that.searchFrames();
					}
				}
			};
		},
		watch: {
			$route(to, from) {
				//监听路由是否变化
				if (to.params.route_url != from.params.route_url) {
					this.route_url = to.params.route_url;
				}
			},
		},
		methods: {
			// 省市区数据
			addressDatalist() {
				this.$api.addressData({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
				}).then((res) => {
					this.addressData_list = res.data;
				}).catch((err) => {
					// console.log(err);
				});
			},
			// 选择省市区
			provinceChange(value) {
				// console.log(value);
			},
			// 默认地址
			change_default() {
				this.address_is_default = this.address_is_default == 0 ? 1 : 0;
			},
			// 默认发票
			change_invoice() {
				this.invoice_is_default = this.invoice_is_default == 0 ? 1 : 0;
			},
			// 部门不限金额
			change_farme() {
				this.frame_is_default = this.frame_is_default == 0 ? 1 : 0;
			},
			//添加发票弹窗
			addInvoice() {
				this.pwShow = false;
				this.xiuGai = 1;
				this.addInvoices = true;
				this.invoice_name = ""; //单位名称
				this.invoice_num = ""; //统一社会信用代码
				this.invoice_address = ""; //注册地址
				this.invoice_phone = ""; //注册电话
				this.invoice_bank = ""; //开户银行
				this.invoice_cartnumber = ""; //银行账号
				this.invoice = '';
			},
			// 添加发票
			addBtnInvoices() {
				this.pwShow = false;
				let access_token = this.$store.state.qycg_user.access_token;
				let type = this.invoiceNum;
				let header = this.invoice_name;
				let taxpayer = this.invoice_num;
				let reg_address = this.invoice_address;
				let reg_phone = this.invoice_phone;
				let reg_bank = this.invoice_bank;
				let bank_number = this.invoice_cartnumber;
				let qycgpay_type = this.$store.state.qycg_user.basics.pay_type;
				let is_default = this.invoice_is_default;
				if (qycgpay_type == 0) {
					this.dep_id = 0;
				} else {
					this.dep_id = this.id;
				}
				let dep_id = this.dep_id;
				this.$loading();
				this.$api.qycgAddInvoice({
					shop_type: 'qycg',
					access_token: access_token,
					dep_id: dep_id,
					type: type,
					header: header,
					taxpayer: taxpayer,
					reg_address: reg_address,
					reg_phone: reg_phone,
					reg_bank: reg_bank,
					bank_number: bank_number,
					is_default: is_default,
				}).then((res) => {
					this.$loading().close();
					this.pwShow = false;
					this.addInvoices = false;
					// console.log(res,111)
					this.$message({
						showClose: true,
						message: '添加成功',
						type: 'success',
						offset: 200,
						duration: 1000
					});
					this.qycgInvoicelist();
				}).catch((err) => {
					this.$loading().close();
					this.pwShow = true;
					this.pwTitle = err.msg;
					// console.log(err);
				});
			},
			// 获取发票列表
			qycgInvoicelist() {
				let qycgpay_type = this.$store.state.qycg_user.basics.pay_type;
				if (qycgpay_type == 0) {
					this.dep_id = 0;
				} else {
					this.dep_id = this.id;
				}
				let dep_id = this.dep_id
				this.$api.qycgInvoice({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					dep_id: dep_id,
				}).then((res) => {
					this.invoice_list = res.data;
					// console.log(this.invoice_list)
				}).catch((err) => {
					// console.log(err);
					this.invoice_list = [];
				});
			},

			// 发票返回值
			getInvoice: function() {
				if (this.invoice == "增值税普通发票") {
					this.invoiceNum = 1;
				} else if (this.invoice == "增值税专用发票") {
					this.invoiceNum = 2;
				} else {
					this.invoiceNum = 0;
				}
			},

			//修改发票弹窗
			modInvoices(index) {
				this.xiuGai = 2;
				this.pwShow = false;
				this.addInvoices = true;
				// console.log(this.invoice_list[index]);
				this.invoice_name = this.invoice_list[index].header;
				this.invoice_num = this.invoice_list[index].taxpayer;
				this.invoice_id =  this.invoice_list[index].id;
				this.invoiceNum = this.invoice_list[index].type;
				if (this.invoiceNum == 1) {
					this.invoice = "增值税普通发票";
				} else if (this.invoiceNum == 2) {
					this.invoice = "增值税专用发票";
					this.invoice_address = this.invoice_list[index].detail.reg_address;
					this.invoice_bank = this.invoice_list[index].detail.reg_bank;
					this.invoice_cartnumber = this.invoice_list[index].detail.bank_number;
					this.invoice_phone = this.invoice_list[index].detail.reg_phone;
				} else {
					this.invoice = '';
				}
			},

			//修改发票
			modifyInvoices() {
				this.pwShow = false;
				let access_token = this.$store.state.qycg_user.access_token;
				let type = this.invoiceNum;
				let header = this.invoice_name;
				let taxpayer = this.invoice_num;
				let reg_address = this.invoice_address;
				let reg_phone = this.invoice_phone;
				let reg_bank = this.invoice_bank;
				let bank_number = this.invoice_cartnumber;
				let qycgpay_type = this.$store.state.qycg_user.basics.pay_type;
				let is_default = this.invoice_is_default;
				let id = this.invoice_id;
				if (qycgpay_type == 0) {
					this.dep_id = 0;
				} else {
					this.dep_id = this.id;
				}
				let dep_id = this.dep_id;
				this.$loading();
				this.$api.qycgAddInvoice({
					shop_type: 'qycg',
					access_token: access_token,
					dep_id: dep_id,
					id: id,
					type: type,
					header: header,
					taxpayer: taxpayer,
					reg_address: reg_address,
					reg_phone: reg_phone,
					reg_bank: reg_bank,
					bank_number: bank_number,
					is_default: is_default,
				}).then((res) => {
					this.$loading().close();
					this.pwShow = false;
					this.addInvoices = false;
					// console.log(res)
					this.$message({
						showClose: true,
						message: '修改成功',
						type: 'success',
						offset: 200,
						duration: 1000
					});
					this.qycgInvoicelist();
				}).catch((err) => {
					this.$loading().close();
					this.pwShow = true;
					this.pwTitle = err.msg;
					// console.log(err);
				});
			},

			//删除发票
			delInvoices(index) {
				let inv_id = this.invoice_list[index].id;
				// console.log(inv_id)
				this.$api.qycgDelInvoice({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					inv_id: inv_id,
				}).then((res) => {
					this.$message({
						showClose: true,
						message: '删除成功',
						type: 'success',
						offset: 200,
						duration: 1000
					});
					this.qycgInvoicelist();
				}).catch((err) => {
					// console.log(err);
				});
			},

			// 添加地址弹窗
			addAddress() {
				this.addressDatalist();
				this.pwShow = false;
				this.xiuGai = 1;
				// this.address_btn = 2;
				this.addAddresslist = true;
				this.address_detail = "";
				this.address_is_default = 0;
				this.consignee_name = "";
				this.consignee_phone = "";
				this.address_province = [];
			},
			// 添加地址
			addBtnaddress() {
				this.pwShow = false;
				let access_token = this.$store.state.qycg_user.access_token;
				let is_default = this.address_is_default;
				let province_id = this.province_id.trim();
				let city_id = this.city_id.trim();
				let district_id = this.district_id.trim();
				let address_province = this.address_province;
				let detail = this.address_detail;
				let name = this.consignee_name;
				let mobile = this.consignee_phone;
				let id = this.id;
				this.$loading();
				this.$api.addressEdit({
					shop_type: 'qycg',
					access_token: access_token,
					dep_id: id,
					is_default: is_default,
					province_id: address_province[0],
					city_id: address_province[1],
					district_id: address_province[2],
					detail: detail,
					name: name,
					mobile: mobile,
				}).then((res) => {
					this.$loading().close();
					this.pwShow = false;
					this.addAddresslist = false;
					this.$message({
						showClose: true,
						message: '添加成功',
						type: 'success',
						offset: 200,
						duration: 1000
					});
					this.getaddressList();
				}).catch((err) => {
					this.$loading().close();
					this.pwShow = true;
					this.pwTitle = err.msg;
					// console.log(err);
				});
			},
			// 部门人员/人员点击
			framePeo(i) {
				this.framePersonal = i;
				this.framePer = i;
			},
			// 获取地址列表
			getaddressList() {
				let id = this.id;
				this.$api.addressList({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					dep_id: id,
				}).then((res) => {
					this.district_list = res.data;
					// console.log(this.district_list)
				}).catch((err) => {
					// console.log(err);
					this.district_list = [];
				});
			},
			// 编辑地址弹窗
			modAddress(index) {
				this.xiuGai = 2;
				this.pwShow = false;
				this.addAddresslist = true;
				let address = this.district_list[index];
				this.address_detail = address.detail;
				this.address_is_default = address.id_default;
				this.consignee_name = address.name;
				this.consignee_phone = address.mobile;
				this.address_id = address.id;
				this.address_province = [Number(address.province_id), Number(address.city_id), Number(address.district_id)];
			},
			// 编辑地址
			modBtnaddress() {
				this.pwShow = false;
				let is_default = this.address_is_default;
				let address_province = this.address_province;
				let detail = this.address_detail;
				let name = this.consignee_name;
				let mobile = this.consignee_phone;
				let id = this.id;
				let address_id = this.address_id;
				this.$loading();
				this.$api.addressEdit({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					dep_id: id,
					is_default: is_default,
					province_id: address_province[0],
					city_id: address_province[1],
					district_id: address_province[2],
					detail: detail,
					name: name,
					mobile: mobile,
					address_id: address_id,
				}).then((res) => {
					this.$loading().close();
					this.pwShow = false;
					this.addAddresslist = false;
					this.$message({
						showClose: true,
						message: '添加成功',
						type: 'success',
						offset: 200,
						duration: 1000
					});
					this.getaddressList();
				}).catch((err) => {
					this.$loading().close();
					this.pwShow = true;
					this.pwTitle = err.msg;
					// console.log(err);
				});
			},
			// 地址详情
			addressDetails(index) {
				let id = this.id;
				let address_id = this.address_id;
				this.$api.addressDetails({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					dep_id: id,
					address_id: addreess_id,
				}).then((res) => {

				}).catch((err) => {
					// console.log(err);
				});
			},
			// 删除地址
			deladdressList(index) {
				let id = this.id;
				let address_id = this.district_list[index].id;
				// console.log(address_id)
				this.$api.delAddress({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					dep_id: id,
					address_id: address_id,
				}).then((res) => {
					// console.log(res)
					this.$message({
						showClose: true,
						message: '删除成功',
						type: 'success',
						offset: 200,
						duration: 1000
					});
					this.getaddressList();
				}).catch((err) => {
					// console.log(err);
				});
			},
			//搜索部门
			searchFrames() {
				this.departmentapi();
				this.personalapi()
			},
			// 获取部门列表
			departmentapi() {
				let keyword = this.searchFrame;
				this.$api.department({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					keyword: keyword,
				}).then((res) => {
					this.frame_list = res.data.list;
					this.searchFrame = '';
					// console.log(res)
					// console.log(this.frame_list);
				}).catch((err) => {
					// console.log(err);
				});
			},
			// 获取成员列表
			personalapi() {
				let id = this.frame_list[this.ind].id;
				let keyword = this.searchFrame;
				this.$api.deppersonal({
					shop_type: 'qycg',
					dep_id: id,
					access_token: this.$store.state.qycg_user.access_token,
					keyword: keyword,
				}).then((res) => {
					this.per_list = res.data;
					this.searchFrame = '';
					// console.log(this.per_list);
				}).catch((err) => {
					// console.log(err);
				});
			},
			// 新建部门弹框
			addFrame() {
				this.pwShow = false;
				this.xiuGai = 1;
				this.addname = "";
				this.addfunds = "";
				this.getSettlement = 2;
				this.dialogFormVisible = true;
			},
			getValue: function() {
				if (this.settlement == "月结") {
					this.getSettlement = 0;
				} else if (this.settlement == "货到付款") {
					this.getSettlement = 1;
				} else {
					this.getSettlement = 2;
				}
			},
			// 添加部门
			addBtnframe() {
				this.pwShow = false;
				let addname = this.$refs.addname.value.trim();
				let addfunds = this.$refs.addfunds.value.trim();
				let pay_type = this.pay_type;
				let is_limit = this.frame_is_default;
				this.$loading();
				// this.$loading().close();
				this.$api.addDepartment({
						shop_type: 'qycg',
						name: addname,
						funds: addfunds,
						pay_type: pay_type,
						is_limit: is_limit,
						access_token: this.$store.state.qycg_user.access_token,
					}).then((res) => {
						this.$loading().close();
						this.pwShow = false;
						this.dialogFormVisible = false;
						this.$message({
							showClose: true,
							message: '添加成功',
							type: 'success',
							offset: 200,
							duration: 1000
						});
						this.departmentapi();
					})
					.catch((err) => {
						this.$loading().close();
						this.pwShow = true;
						this.pwTitle = err.msg;
						// console.log(err);
					});
			},
			// 修改部门弹框
			modifyFrame(index) {
				this.xiuGai = 2;
				this.pwShow = false;
				this.dialogFormVisible = true;
				this.addname = this.frame_list[index].name;
				this.addfunds = this.frame_list[index].funds;
				this.getSettlement = this.frame_list[index].pay_type;
				this.id = this.frame_list[index].id;
			},
			//修改部门
			modBtnframe() {
				this.pwShow = false;
				let addname = this.$refs.addname.value.trim();
				let addfunds = this.$refs.addfunds.value.trim();
				let id = this.id;
				let getSettlement = this.getSettlement;
				let is_limit = this.frame_is_default;
				// console.log(getSettlement)
				if (addname == "") {
					this.pwTitle = "请输入部门名称";
					this.pwShow = true;
				} else if (getSettlement === 2) {
					this.pwTitle = "请输入结算方式";
					this.pwShow = true;
				} else {
					this.$loading();
					// this.$loading().close();
					this.$api.modifyDepartment({
						shop_type: 'qycg',
						access_token: this.$store.state.qycg_user.access_token,
						name: addname,
						funds: addfunds,
						pay_type: getSettlement,
						id: id,
						is_limit: is_limit,
					}).then((res) => {
						// location.reload();
						this.$loading().close();
						this.pwShow = false;
						this.dialogFormVisible = false;
						this.$message({
							showClose: true,
							message: '修改成功',
							type: 'success',
							offset: 200,
							duration: 1000
						});
						this.departmentapi()
					}).catch((err) => {
						this.$loading().close();
						this.pwTitle = err.msg;
						// console.log(err);
					});

				}
			},
			handleOpen(key, keyPath) {
				// console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				// console.log(key, keyPath);
			},
			showdifference(index) {
				this.address_btn = 1;
				if (this.framePersonal == 1) {
					this.framePer = 1;
				} else if (this.framePersonal == 2) {
					this.framePer = 2;
				} else if (this.framePersonal == 3) {
					this.framePer = 3;
				} else {
					this.framePer = 0;
				}
				this.isActive = index;
				this.ind = index;
				this.id = this.frame_list[this.ind].id;
				this.addname = this.frame_list[this.ind].name;
				this.funds = (this.frame_list[this.ind].funds);
				this.pay_type = this.frame_list[this.ind].pay_type;
				this.is_limit = (this.frame_list[this.ind].is_limit);
				this.personalapi();
				this.getaddressList();
				this.qycgInvoicelist();
			},
			clickbj(index) {
				this.isBianji = index
			},
			mouseLeave(index) {
				this.isBianji = -1
			},
			// 删除部门
			deleteFrame(index) {
				let id = this.frame_list[index].id;
				// console.log(this.frame_list[index].id)
				this.$confirm('确认删除当前部门吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false,
				}).then(() => {
					this.$api.delDepartment({
						shop_type: 'qycg',
						access_token: this.$store.state.qycg_user.access_token,
						dep_id: id,
					}).then(res => {
						if (res.code == 0) {
							location.reload();
							this.$message({
								showClose: true,
								message: '删除成功',
								type: 'success',
								offset: 200,
								duration: 1000
							});
						}
					}).catch(err => {
						this.pwTitle = err.msg;
						// console.log(err);
					});
				}).catch(() => {});
			},
			// 添加人员弹窗
			addPeople() {
				this.pwShow = false;
				this.xiuGai = 1;
				this.addMembers = true;
				this.pername = "";
				this.pertext = "";
				this.perpassword = "";
				this.perphone = "";
				this.examine = "";
			},
			// 审核人返回值
			getExamine: function() {
				if (this.examine == "审核员") {
					this.examineNum = 1;
				} else if (this.examine == "采购员") {
					this.examineNum = 2;
				} else {
					this.examineNum = 0;
				}
			},
			// 添加成员
			addBtnpeople() {
				this.pwShow = false;
				let pername = this.$refs.pername.value.trim();
				let pertext = this.$refs.pertext.value.trim();
				let perpassword = this.$refs.perpassword.value.trim();
				let perphone = this.$refs.perphone.value.trim();
				let examineNum = this.examineNum;
				let id = this.id;
				if (pername == "") {
					this.pwTitle = "请输入姓名";
					this.pwShow = true;
				} else if (examineNum === 0) {
					this.pwTitle = "请选择审批人";
					this.pwShow = true;
				} else if (pertext == "") {
					this.pwTitle = "请输入账号";
					this.pwShow = true;
				} else if (perpassword == "") {
					this.pwTitle = "请输入密码";
					this.pwShow = true;
				} else if (perphone == "") {
					this.pwTitle = "请输入手机号";
					this.pwShow = true;
				} else {
					this.$loading();
					// this.$loading().close();
					this.$api.personalEditor({
						shop_type: 'qycg',
						access_token: this.$store.state.qycg_user.access_token,
						nickname: pername,
						level: examineNum,
						username: pertext,
						password: perpassword,
						phone: perphone,
						department_id: id,
					}).then((res) => {
						// location.reload();
						this.$loading().close();
						this.pwShow = false;
						this.addMembers = false;
						this.$message({
							showClose: true,
							message: '添加成功',
							type: 'success',
							offset: 200,
							duration: 1000
						});
						this.personalapi();
					}).catch((err) => {
						this.$loading().close();
						this.pwShow = true;
						this.pwTitle = err.msg;
						// console.log(err);
					});
				}
			},
			// 修改成员弹框
			modPerson(index) {
				// console.log(this.per_list[index])
				this.xiuGai = 2;
				this.pwShow = false;
				this.addMembers = true;
				this.per_id = this.per_list[index].id
				this.examineNum = this.per_list[index].level;
				if (this.examineNum == 1) {
					this.examine = "审核员";
				} else if (this.examineNum == 2) {
					this.examine = "采购员";
				} else {
					this.examine = 0;
				}
				this.pername = this.per_list[index].nickname;
				this.perphone = this.per_list[index].phone;
				this.perpassword = this.per_list[index].password;
				this.pertext = this.per_list[index].username;
				this.id = this.id;
			},
			// 修改成员
			modifyPerson(index) {
				this.pwShow = false;
				let per_id = this.per_id;
				let examineNum = this.examineNum;
				let pername = this.pername;
				let perphone = this.perphone;
				let perpassword = this.perpassword;
				let pertext = this.pertext;
				let id = this.id;
				if (pername == "") {
					this.pwTitle = "请输入姓名";
					this.pwShow = true;
				} else if (examineNum === 0) {
					this.pwTitle = "请选择审批人";
					this.pwShow = true;
				} else if (pertext == "") {
					this.pwTitle = "请输入账号";
					this.pwShow = true;
				} else if (perpassword == "") {
					this.pwTitle = "请输入密码";
					this.pwShow = true;
				} else if (perphone == "") {
					this.pwTitle = "请输入手机号";
					this.pwShow = true;
				} else {
					this.$loading();
					this.$api.personalEditor({
						shop_type: 'qycg',
						access_token: this.$store.state.qycg_user.access_token,
						nickname: pername,
						level: examineNum,
						username: pertext,
						password: perpassword,
						phone: perphone,
						department_id: id,
						id: per_id,
					}).then((res) => {
						this.$loading().close();
						this.pwShow = false;
						this.addMembers = false;
						this.$message({
							showClose: true,
							message: '修改成功',
							type: 'success',
							offset: 200,
							duration: 1000
						});
						this.personalapi();
					}).catch((err) => {
						this.$loading().close();
						this.pwShow = true;
						this.pwTitle = err.msg;
						// console.log(err);
					});
				}
			},
			// 删除成员
			deletePersone(index) {
				this.pwShow = false;
				let id = this.per_list[index].id;
				this.$confirm('确认删除当前部门吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false,
				}).then(() => {
					this.$api.personalDelete({
						shop_type: 'qycg',
						access_token: this.$store.state.qycg_user.access_token,
						user_id: id,
					}).then(res => {
						this.pwShow = false;
						this.addMembers = false;
						this.$message({
							showClose: true,
							message: '删除成功',
							type: 'success',
							offset: 200,
							duration: 1000
						});
						this.personalapi();
					}).catch(err => {
						this.pwShow = true;
						this.pwTitle = err.msg;
						// console.log(err);
					});
				}).catch(() => {});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.framework {
		width: 100%;
		background: #F2F2F2;
		padding-top: 20px;

		.frame {
			margin: 0 auto;
			padding-top: 32px;
			width: 1080px;
			height: 740px;
			background: #FFFFFF;
			display: flex;

			.frame-left {
				width: 255px;
				margin-top: -32px;
				font-size: 14px;
				height: 733px;

				.frame-left-top {
					width: 48px;
					height: 12px;
					font-size: 12px;
					margin-top: 20px;
					margin-left: 16px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					line-height: 12px;
				}

				.frame-left-ss {
					margin-left: 16px;
					margin-top: 14px;
					width: 182px;
					height: 32px;
					background: #FFFFFF;
					border: 1px solid #F5F5F5;
					display: flex;

					.left-ss {
						width: 16px;
						height: 16px;
						margin: 8px 4px 0 8px;
					}

					.left-tj {
						width: 20px;
						height: 20px;
						margin: auto;
						margin-right: -39px;
						cursor: pointer;
					}
				}

				.zz {
					width: 14px;
					height: 14px;
					float: right;
					position: relative;
					top: 17px;
					left: 30px;
				}

				.grouping {
					height: 40px;
					color: #333333;
					margin-top: -20px;
					margin-left: -40px;
				}

				.el-personal {
					box-sizing: border-box;
					color: #333333;
					border-left: 2px solid transparent;
					width: 255px;
					height: 40px;
					margin-top: 12px;
					font-size: 14px;
					line-height: 40px;
					text-align: center;
					position: relative;
					cursor: pointer;

					i {
						font-size: 14px;
					}

					.zz {
						width: 14px;
						height: 14px;
						float: right;
						position: relative;
						top: 17px;
						left: -20px;
					}

					.box {
						width: 104px;
						height: 64px;
						position: absolute;
						right: 12px;
						top: 35px;
						box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.2);
						z-index: 100;
						display: none;
						background: #FFFFFF;

						.edit {
							width: 104px;
							height: 32px;
							line-height: 32px;
							text-align: center;
						}
					}

					.disbox {
						display: block;
					}
				}

				.active {
					border-left: 2px solid red;
					color: #FF3259;
					width: 255px;
					box-sizing: border-box;
					height: 40px;
					background: rgba(255, 0, 0, 0.1);

					i {
						color: red;
					}
				}
			}

			.frame-right {
				width: 825px;
				height: 733px;
				box-sizing: border-box;
				border-left: 1px solid #F5F5F5;
				margin-top: -32px;

				.frame-right-top {
					display: flex;
					min-height: 46px;
					_height: 46px;
					justify-content: space-between;

					.right-top-txt {
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
						margin-top: 20px;
						margin-left: 24px;
						display: flex;

						.frame-personal {
							width: 100px;
							height: 30px;
							font-size: 16px;
							border-radius: 15px;
							border: 1px black solid;
							text-align: center;
							line-height: 30px;
							margin-right: 12px;
							cursor: pointer;
						}

						.active {
							border: 1px red solid;
							color: red;
						}
					}

					.right-top-button {
						display: flex;

						.right-top-btn {
							margin-top: 16px;
							margin-right: 24px;
							width: 80px;
							height: 28px;
							border-radius: 14px;
							border: 1px solid #FF2C51;
							font-size: 14px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #FF2C51;
							line-height: 28px;
							text-align: center;
							cursor: pointer;

							.el-button-text {
								width: 80px;
								height: 33px;
							}
						}
					}
				}

				.frame-right-center {
					width: 777px;
					height: 106px;
					background: #F5F5F5;
					border-radius: 4px;
					margin: 16px auto 0;
					display: flex;

					.right-center-funds {
						height: 60px;
						text-align: center;
						margin-top: 23px;
						text-indent: 24px;

						p {
							font-size: 12px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
							line-height: 12px;
							margin-bottom: 3px;

							span {
								height: 45px;
								font-size: 32px;
								font-weight: 600;
								line-height: 45px;
							}
						}
					}

					.right-center-funds-one {
						border-right: 1px solid #D8D8D8;
						padding-right: 12px;
					}
				}

				.frame-right-tab {
					width: 777px;
					margin: 10px auto 0;

					.right-tab {
						border-collapse: collapse;

						tr {
							height: 40px;

							th {
								text-align: left;
							}

							th:first-child {
								text-indent: 16px;
							}

							td:first-child {
								text-indent: 16px;

								span {
									display: inline-block;
									border: 1px solid red;
									text-indent: 0px;
									background: rgba($color: pink, $alpha: 0.6);
									margin-left: 6px;
									border-radius: 3px;
								}
							}
						}

						tr:nth-child(odd) {
							/*奇数行*/
							background: #FAFAFA;
						}

						.operation {
							span {
								width: 24px;
								height: 12px;
								font-size: 12px;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #3AB2F1;
								line-height: 12px;
								margin-right: 16px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}

	// 新建部门 /添加成员
	.addpersonal {
		width: 480px;
		min_height: 302px;
		background: #EBEBEB;

		.add-per {
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.ttshop_singtop {
				width: 100%;
				height: 30px;
				background: #fff0f1;
				padding: 0 15px;
				line-height: 30px;
				margin: 8px 0;
				box-sizing: border-box;
				opacity: 0;
				filter: alpha(opacity=0);

				p {
					i {
						display: inline-block;
						width: 12px;
						height: 12px;
						border-radius: 50%;
						margin-right: 6px;
						vertical-align: -2px;

						img {
							display: block;
							width: 100%;
							height: 100%;
							border-radius: 50%;
						}
					}

					span {
						font-size: 12px;
						color: #ff0e25;
					}
				}

				.address-mask-l {
					width: 60px;
					margin-right: 16px;

					.item-title {
						height: 28px;
						line-height: 28px;
						margin-bottom: 20px;
					}
				}

				.address-mask-r {
					.hint {
						height: 20px;
						color: #ff8500;

						.hint-img {
							height: 12px;
							width: 12px;
							margin-right: 8px;
						}
					}

					.default {
						.default-img {
							height: 12px;
							width: 12px;
							margin-right: 4px;
						}
					}

					.address-btn {
						width: 108px;
						height: 32px;
						background: #ff0e25;
						border-radius: 2px;
						color: #fff;
						margin-top: 38px;
					}
				}
			}

			.ttshop_singtop_active {
				opacity: 1 !important;
				filter: alpha(opacity=100) !important;
			}

			.add-data {
				width: 400px;
				margin-bottom: 20px;

				span {
					display: block;
					width: 100px;
					height: 28px;
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					text-align: right;
					line-height: 28px;
					float: left;

					i {
						margin-right: 3px;
						font-style: normal;
						color: red;
					}
				}

				.add-data-ress {
					line-height: 40px;
				}



				input {
					width: 280px;
					height: 28px;
					border: 1px solid #EBEBEB;
					border-radius: 2px;
					text-indent: 12px;
					box-sizing: border-box;
				}

				input::-webkit-input-placeholder {
					color: #999999;
				}

				input::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: #999999;
				}

				input:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: #999999;
				}

				input:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: #999999;
				}

				select {
					width: 280px;
					height: 28px;
					border: 1px solid #EBEBEB;
					outline: none;
					color: #999999;

					option {
						color: #999999;
						outline: none;
						text-indent: 12px;
					}
				}
			}

			.add-data-end {
				display: flex;
				justify-content: center;
				align-items: center;

				.default-img {
					height: 12px;
					width: 12px;
					margin-right: 4px;
				}
			}
		}

		.newly-build {
			width: 108px;
			height: 32px;
			background: #FF0E25;
			border-radius: 2px;
			font-size: 12px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #FFFFFF;
			line-height: 32px;
			text-align: center;
			margin-top: 20px;
			margin-bottom: 10px;
			margin-left: 150px;
			cursor: pointer;
		}
	}
</style>
